export default "__VITE_ASSET__BDbGNgtW__"